import { ICultureResources } from '../../models/resource.model';
import rawBaiduScript from './../inline-scripts/baidu.script';
import rawGtmLoaderChina from './../inline-scripts/google-tag-manager-china.script';
import rawPardotConsentReadyChina from './../inline-scripts/pardot-consent-ready-china.script';

export const zhHans: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans SC Variable',
        fontFamilyText: 'Noto Sans SC Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans-sc/files/noto-sans-sc-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans-sc/index.css',
                rel: 'stylesheet',
            },
        },
    ],
    scripts: [
        {
            tag: 'script',
            location: 'head',
            attributes: {
                type: 'text/javascript',
                async: true,
                src: 'https://snap.licdn.com/li.lms-analytics/insight.min.js?raw',
            },
        },
        {
            tag: 'script',
            location: 'head',
            textContent: rawGtmLoaderChina,
            attributes: { type: 'text/javascript', id: 'gtm-loader-china-inline' },
        },
        {
            tag: 'script',
            location: 'head',
            textContent: rawPardotConsentReadyChina,
            attributes: { type: 'text/javascript', id: 'pardot-consent-china-inline' },
        },
        {
            tag: 'script',
            location: 'head',
            textContent: rawBaiduScript,
            attributes: { type: 'text/javascript', id: 'baidu-analytics-inline' },
        },
    ],
    noscripts: [
        {
            tag: 'noscript',
            location: 'body',
            attributes: { id: 'linkedin-px' },
            textContent:
                '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2176348&fmt=gif" />',
        },
        {
            tag: 'noscript',
            location: 'body',
            attributes: { id: 'gtm-noscript-china' },
            textContent:
                '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W8G2FMKC" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
        },
    ],
    meta: [
        {
            tag: 'meta',
            location: 'head',
            attributes: {
                name: '360-site-verification',
                content: 'dd3411adf0483f385490bbb27115bb35',
            },
        },
        {
            tag: 'meta',
            location: 'head',
            attributes: { name: 'sogou_site_verification', content: 'p0c5q9whw5' },
        },
    ],
};
